module.exports = __webpack_public_path__ + "img/dr.hoangtuan(cam-tim).1be22e45.png";